import s from "./component-library243.js";
/* empty css                     */
import o from "./component-library98.js";
const d = {
  name: "BundleConfigurator",
  components: { BundleConfiguratorItem: s },
  props: {
    focusedItemIndex: { type: Number, default: void 0 },
    bundleItems: { type: Array, default: () => [] }
  },
  emits: ["select-variant"],
  data() {
    return { openItemIndex: this.focusedItemIndex };
  },
  methods: {
    handleOpenItemChange({ position: n }) {
      this.openItemIndex === n ? this.openItemIndex = void 0 : this.openItemIndex = n;
    },
    isOpen({ position: n }) {
      return this.openItemIndex === n;
    }
  }
};
var i = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "bundle-configurator" }, [t("div", { staticClass: "bundle-configurator__header" }, [e._v("Bestehend aus:")]), e._l(e.bundleItems, function(r) {
    return t("BundleConfiguratorItem", { key: r.family.slug, attrs: { "bundle-item": r, "is-extended": e.isOpen(r) }, on: { "open-bundle-item-config": e.handleOpenItemChange, "select-variant": (a) => e.$emit("select-variant", a) } });
  })], 2);
}, u = [], m = /* @__PURE__ */ o(
  d,
  i,
  u,
  !1,
  null,
  "a2ac232e"
);
const p = m.exports;
export {
  p as default
};
